<div class="d-flex justify-content-center align-items-center vh-100">
    <button type="button" class="btn btn-primary" (click)="login()">Login</button>
    <button type="button" class="btn btn-danger" (click)="logout()">Logout</button>
    <!-- <a class="border rounded-5 nav-link text-black bg-white  mobile " role="button" 
    href="/auth-callback">Logg inn</a> -->
  </div>